import { call } from "redux-saga/effects";
import { ACTIONS, APIS } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

// Campaign
export function* searchCampaign(action: any): any {
    const yieldPuts = [{ type: ACTIONS.MARKETING_CAMPAIGN.SEARCH, payload: "items" }];
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING_CAMPAIGN.SEARCH, action.payload, true, yieldPuts);
}

export function* insertUpdateCampaign(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING_CAMPAIGN.INSERT_UPDATE, action.payload, true);
}

export function* deleteCampaign(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING_CAMPAIGN.DELETE, action.payload, true);
}

export function* campaignDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.MARKETING_CAMPAIGN.DETAILS + action.payload, null, true);
}

export function* campaignDeliveries(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING_CAMPAIGN.DELIVERIES, action.payload, true);
}

// Audience List
export function* searchAudienceList(action: any): any {
    const yieldPuts = [{ type: ACTIONS.MARKETING_AUDIENCE_LIST.SEARCH, payload: "items" }];
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING_AUDIENCE_LIST.SEARCH, action.payload, true, yieldPuts);
}

export function* insertUpdateAudienceList(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING_AUDIENCE_LIST.INSERT_UPDATE, action.payload, true);
}

export function* deleteAudienceList(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING_AUDIENCE_LIST.DELETE, action.payload, true);
}

export function* audienceListDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.MARKETING_AUDIENCE_LIST.DETAILS + action.payload, null, true);
}

export function* bulkUpsertMembers(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING_AUDIENCE_LIST.BULK_UPSERT_MEMBERS, action.payload, true);
}

export function* addFromGroups(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING_AUDIENCE_LIST.ADD_FROM_GROUPS + action.payload.id, action.payload.data, true);
}

// Marketing General
export function* getMasterTags(action: any): any {
    const yieldPuts = [{ type: ACTIONS.MARKETING.MASTER_TAGS, payload: "items" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.MARKETING.MASTER_TAGS + "?channel=" + (action.payload?.channel || ""), null, true, yieldPuts);
}

export function* validateTags(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING.VALIDATE_TAGS, action.payload, true);
}

export function* previewContent(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING.PREVIEW_CONTENT, action.payload, true);
}

export function* getSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.MARKETING.GET_SETTINGS, null, true);
}

export function* saveEmailSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING.SAVE_EMAIL_SETTINGS, action.payload, true);
}

export function* saveSmsSettings(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.MARKETING.SAVE_SMS_SETTINGS, action.payload, true);
}
